import React, { Component } from "react";
import { Route } from "react-router-dom";
import Signupscreen from "./signupscreen/signupscreen";
import Signinscreen from "./signInscreen/signInscreen";
import Signinpassword from "./signInpassword/signinpassword";
import Signuppassword from "./signuppassword/signuppassword";
import Validateuser from "./validateuser/validateuser";
import Uploadresume from "./uploadresume/uploadrresume";
import ForgetPassword from "./forgotPassword/forgotPass";
import ForPass from "./forgotPassword/forPass";
// import Sidebar from '../../component/dashboard/sidebar/Sidebar'
// import Main from '../dashboard/main/main'
// import Dashnavigation from "../dashboard/navigation/dashbnavigation";

// import Myprofile from '../my_profile/MyProfile'

// index component for routing begore login

class Index extends Component {
  /**
   * This function to avoid the browser back button after user login to the website if he click on the back  button without logout it won't go back to home page.
   */
  componentDidMount() {
    function preback() {
      window.history.forward();
    }
    setTimeout(() => {
      preback();
    }, 0);
    window.onunload = function () {
      return null;
    };
  }

  render() {
    return (
      <div>
        {/* <Route   path="/" component={Navigation} /> */}
        <Route exact path="/" component={Signinscreen} />
        <Route exact path="/signup" component={Signupscreen} />
        <Route exact path="/signin" component={Signinscreen} />
        <Route exact path="/signin_password" component={Signinpassword} />
        <Route exact path="/signup_password" component={Signuppassword} />
        <Route path="/validateuser" component={Validateuser} />
        <Route exact path="/uploadresume" component={Uploadresume} />
        <Route exact path="/forget_password" component={ForgetPassword} />
        <Route exact path="/forget" component={ForPass} />
      </div>
    );
  }
}
export default Index;
